import { Updater } from '@ngneat/query';

import { IDocumentTranslation, IDocumentVersion } from '../types';

export const updateQueryDocumentFile = (
  documentId: string,
  fileData: IDocumentTranslation,
): Updater<IDocumentVersion[], IDocumentVersion[]> => {
  return function (state: IDocumentVersion[]) {
    const list = Array.isArray(state) ? [...state] : [];
    const idx = list?.findIndex((el: IDocumentVersion) => el.id === documentId);

    if (idx > -1) {
      const translations = [...(list[idx].translations || [])];
      const translationIdx = translations.findIndex((tr) => tr.language === fileData.language);

      if (translationIdx > -1) {
        translations[translationIdx] = { ...translations[translationIdx], ...fileData };
      } else {
        translations.push(fileData);
      }

      list[idx] = { ...list[idx], translations };
    }

    return list;
  };
};
